import { useState } from "react";

import {
  ActionIcon,
  Button,
  Card,
  Container,
  Divider,
  Group,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
  Title,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { IconCopy } from "@tabler/icons-react";

import { translateText } from "@/api/translate";

const PLACEHOLDER = "-";

export function Translate() {
  const [english, setEnglish] = useState("");
  const [translations, setTranslations] = useState<Record<string, string>>({
    greek: PLACEHOLDER,
    german: PLACEHOLDER,
    french: PLACEHOLDER,
    dutch: PLACEHOLDER,
  });
  const [loading, setLoading] = useState(false);

  const handleTranslate = async () => {
    setLoading(true);
    try {
      const result = await translateText(english);
      setTranslations(result);
    } finally {
      setLoading(false);
    }
  };

  const copy = (text: string, label: string) => {
    navigator.clipboard.writeText(text);
    notifications.show({ message: `Copied ${label}`, color: "sea" });
  };

  const labels: Array<[keyof typeof translations, string]> = [
    ["greek", "Greek"],
    ["german", "German"],
    ["french", "French"],
    ["dutch", "Dutch"],
  ];

  return (
    <Container size="lg">
      <Stack gap="lg">
        <Title order={1}>Translation Helper</Title>
        <Textarea
          autosize
          minRows={3}
          placeholder="Type or paste English here…"
          value={english}
          onChange={(event) => setEnglish(event.currentTarget.value)}
          radius="lg"
        />
        <Group>
          <Button
            disabled={english.length === 0}
            loading={loading}
            onClick={handleTranslate}
            color="sea"
          >
            Translate
          </Button>
        </Group>
        <Divider />
        <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }} spacing="md">
          {labels.map(([key, label]) => (
            <Card key={key} withBorder p="md">
              <Group justify="space-between" mb="xs">
                <Title order={5}>{label}</Title>
                <ActionIcon
                  variant="subtle"
                  onClick={() => copy(translations[key], label)}
                  aria-label={`Copy ${label}`}
                >
                  <IconCopy size={16} />
                </ActionIcon>
              </Group>
              <Text size="sm" style={{ whiteSpace: "pre-wrap" }}>
                {translations[key]}
              </Text>
            </Card>
          ))}
        </SimpleGrid>
      </Stack>
    </Container>
  );
}

export default Translate;
